import type {
  ListProjectsMinimalDTO,
  ListProjectsMinimalParams,
} from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { getProjectsQueryKey } from "@/hooks/queryKeys.ts";
import apiClient from "@/lib/api/client";

export function useListProjectsMinimal(
  params?: ListProjectsMinimalParams,
): UseQueryResult<ListProjectsMinimalDTO, Error> {
  return useQuery({
    queryFn: () =>
      apiClient
        .url("/projects/minimal")
        .query(params || {})
        .get()
        .json<ListProjectsMinimalDTO>(),
    queryKey: getProjectsQueryKey(params),
  });
}
